import { ChangeDetectionStrategy, Component, output } from '@angular/core';

@Component({
  selector: 'coin-prompt-button',
  templateUrl: './prompt-button.component.html',
  styleUrl: './prompt-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class PromptButtonComponent {
  press = output<void>();
}
